import React from "react";
import Icon from "@ant-design/icons";
import {
  IncreaseArrowSvg,
  DecreaseArrowSvg,
  EqualSvg,
} from "../../assets/icons.tsx";

export const IncreaseIcon = (props) => (
  <Icon
    component={IncreaseArrowSvg}
    {...props}
  />
);

export const DecreaseIcon = (props) => (
  <Icon
    component={DecreaseArrowSvg}
    {...props}
  />
);

export const EqualIcon = (props) => (
  <Icon
    component={EqualSvg}
    {...props}
  />
);
